export default "__VITE_ASSET__Dg1zv0Sn__"